"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _lodash = require("lodash");
var _ = require("./..");
var _api = require("./api");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var IntakeSummary = function IntakeSummary(_ref) {
  var surveyData = _ref.surveyData,
    expanded = _ref.expanded,
    onClickDetail = _ref.onClickDetail;
  var _useIntakeSurveyMedic = (0, _api.useIntakeSurveyMedicationAssessment)(surveyData),
    questions = _useIntakeSurveyMedic.questions;
  var adjustedSurveyData = (0, _react.useMemo)(function () {
    return questions ? _objectSpread(_objectSpread({}, surveyData), {}, {
      survey: _objectSpread(_objectSpread({}, survey), {}, {
        sections: (0, _lodash.chain)(questions).orderBy('order').groupBy(function (question) {
          return question.surveySectionId;
        }).values().orderBy('0.surveySection.order').value()
      })
    }) : surveyData;
  }, [surveyData, questions]);
  var survey = adjustedSurveyData.survey,
    patientSurveyAnswers = adjustedSurveyData.patientSurveyAnswers;
  return /*#__PURE__*/_react.default.createElement(_.PatientSurvey, {
    title: "Intake Summary",
    surveyData: adjustedSurveyData,
    expanded: expanded,
    onClickDetail: onClickDetail
  }, (survey === null || survey === void 0 ? void 0 : survey.sections) && (0, _lodash.map)(survey.sections, function (questions, sectionName) {
    return /*#__PURE__*/_react.default.createElement(_.SurveySection, {
      key: sectionName
    }, questions.map(function (question) {
      var answer = (0, _.getAnswerForQuestion)(question, patientSurveyAnswers);
      return /*#__PURE__*/_react.default.createElement(_.Question, {
        key: question.id,
        question: question,
        answer: answer
      });
    }));
  }));
};
var _default = IntakeSummary;
exports.default = _default;